import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate path (optional - will be auto-generated if not provided)
  if (properties.path && !properties.path.startsWith('/')) {
    errors.push({ key: 'path', message: 'Webhook path must start with /' });
  }

  // Validate method
  const validMethods = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
  if (!properties.method || !validMethods.includes(properties.method)) {
    errors.push({ key: 'method', message: 'Invalid HTTP method' });
  }

  // Validate responseData if provided
  if (properties.responseData) {
    try {
      JSON.parse(properties.responseData);
    } catch (e) {
      errors.push({ key: 'responseData', message: 'Response data must be valid JSON' });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
